import { queryOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { Admin } from '@/lib/auth/auth-types'
import { fetcher } from '@/lib/fetcher'
import { ENDPOINTS } from '@/query-client'

import { Permissions } from './auth-types'

export const currentAdminQueryOptions = queryOptions<
  API<Admin>,
  AxiosError<API>
>({
  queryFn: async () =>
    await fetcher<Admin>(ENDPOINTS.AUTH.GET_CURRENT_USER, { auth: true }),
  queryKey: ['current-admin']
})

export const getAllAdministrationPermissions = queryOptions<
  API<Permissions>,
  AxiosError<API>,
  API<Permissions>
>({
  queryFn: async () =>
    await fetcher<Permissions>(ENDPOINTS.AUTH.GET_CURRENT_USER_PERMISSIONS, {
      auth: true
    }),
  queryKey: ['permissions']
})
